var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigoPetTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0F2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1656_2090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 30C19.5 31.1935 19.9741 32.3381 20.818 33.182C21.6619 34.0259 22.8065 34.5 24 34.5C25.1935 34.5 26.3381 34.0259 27.182 33.182C28.0259 32.3381 28.5 31.1935 28.5 30C28.5 28.8065 28.0259 27.6619 27.182 26.818C26.3381 25.9741 25.1935 25.5 24 25.5C22.8065 25.5 21.6619 25.9741 20.818 26.818C19.9741 27.6619 19.5 28.8065 19.5 30Z",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18C13.5 15.515 18.2 13.5 24 13.5C29.8 13.5 34.5 15.515 34.5 18",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9053 20.25C16.7203 18.905 20.1143 18 24.0003 18C27.8863 18 31.2803 18.905 33.0953 20.25",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 26.193C32.72 25.38 34.5 24.029 34.5 22.5V18C34.5 20.485 29.8 22.5 24 22.5C18.2 22.5 13.5 20.485 13.5 18V22.5C13.5 24.029 15.279 25.38 18 26.193",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 25.5V29.625",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 29.625C24.0995 29.625 24.1948 29.6645 24.2652 29.7348C24.3355 29.8052 24.375 29.9005 24.375 30",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.625 30C23.625 29.9005 23.6645 29.8052 23.7348 29.7348C23.8052 29.6645 23.9005 29.625 24 29.625",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 30.375C23.9005 30.375 23.8052 30.3355 23.7348 30.2652C23.6645 30.1948 23.625 30.0995 23.625 30",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 30C24.375 30.0995 24.3355 30.1948 24.2652 30.2652C24.1948 30.3355 24.0995 30.375 24 30.375",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1656_2090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigoPetTag);
export default __webpack_public_path__ + "static/media/figo-pet-tag.91a4ba5a01f2c781e170e526560ec2d5.svg";
export { ForwardRef as ReactComponent };